export default "__VITE_ASSET__f08ab70f__"